module.exports = __webpack_public_path__ + "spine/windmill_blades.json?1ed6df8efd3ba714124151c9c119bde5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spine/windmill/windmill_blades.json
// module id = 1749
// module chunks = 3